import React, { useState, useEffect, memo, useRef } from 'react';
import debounce from 'lodash/debounce';

import bn from '../../../generalUtils/benames';

const bem = bn.create('scrollToTopBottom');

const ScrollToTopBottom = props => {
  const { elementRef, filteredData, setEndIndex } = props;

  const [isTopVisible, setIsTopVisible] = useState(false);
  const [isBottomVisible, setIsBottomVisible] = useState(false);
  const contentBodyRef = useRef(null);
  const SCROLLOFFSET = 720;

  const scrollToTop = position => {
    const container = contentBodyRef?.current;

    if (container) {
      if (position === 'bottom') {
        container.scrollTo({
          top: container?.scrollHeight,
          behavior: 'smooth'
        });
      } else {
        // const currentScrollTop = container?.scrollTop;
        // const newScrollTop = Math.max(0, currentScrollTop - 2000);
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  };

  useEffect(() => {
    contentBodyRef.current = elementRef?.current || window;
  }, [elementRef]);

  useEffect(() => {
    const handleScroll = debounce(() => {
      const container = contentBodyRef?.current;

      if (container) {
        const { scrollTop, clientHeight, scrollHeight } = container;
        if (scrollTop + clientHeight < SCROLLOFFSET) {
          setEndIndex(30);
        } else if (scrollHeight - (scrollTop + clientHeight) < SCROLLOFFSET) {
          setEndIndex(prevEndIndex => prevEndIndex + props.APPEND_ROWS);
        }

        ///////////////////////

        const scrollY = scrollTop;
        setIsTopVisible(scrollY >= SCROLLOFFSET);

        if (filteredData.length > 0) {
          const tbodyElement = container.querySelector('tbody');
          if (tbodyElement) {
            const trCount = tbodyElement.querySelectorAll('tr').length;
            setIsBottomVisible(trCount !== filteredData.length);
          }
        }
        if (scrollY < SCROLLOFFSET) {
          setIsBottomVisible(false);
        }
      }
    }, 50);

    const container = contentBodyRef?.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [contentBodyRef?.current, filteredData]);

  return (
    <div className={bem.b('')}>
      {isTopVisible && (
        <div className="arrow-container" onClick={() => scrollToTop('top')}>
          <div className="btn btn-sm arrow">
            <i className="fa fa-chevron-up" />
          </div>
        </div>
      )}
      {isBottomVisible && (
        <div className="arrow-container" onClick={() => scrollToTop('bottom')}>
          <div className="btn btn-sm arrow">
            <i className="fa fa-chevron-down" />
          </div>
        </div>
      )}
    </div>
  );
};

ScrollToTopBottom.displayName = 'ScrollToTopBottom';
export default memo(ScrollToTopBottom);
